import React from "react";
import { Eye, AlertCircle } from "lucide-react";
import StatusBadge from "./StatusBadge";
import TATTimer from "./TATTimer";

export default function ECGCaseRow({ patient, onView }) {
  return (
    <tr
      className={`border-b border-[#E5E7EB] last:border-b-0 transition-colors ${
        patient.urgent
          ? "bg-red-50 hover:bg-red-100"
          : "hover:bg-[#F9FAFB]"
      }`}
    >
      {/* Patient ID */}
      <td className="px-3 py-3 text-sm font-medium text-[#1F2937] whitespace-nowrap">
        {patient.PatientId}
      </td>

      {/* Patient Name */}
      <td className="px-3 py-3 text-sm text-[#1F2937] whitespace-nowrap">
        {patient.PatientName}
      </td>

      {/* Age */}
      <td className="px-3 py-3 text-sm text-[#6B7280]">
        {patient.age ?? "—"}
      </td>

      {/* Gender */}
      <td className="px-3 py-3 text-sm text-[#6B7280]">
        {patient.gender ?? "—"}
      </td>

      {/* Heart Rate */}
      <td
        className={`px-3 py-3 text-sm ${
          patient.urgent
            ? "text-[#DC2626] font-semibold"
            : "text-[#6B7280]"
        }`}
      >
        {patient.HeartRate ?? "—"}
      </td>

      {/* PR Interval */}
      <td className="px-3 py-3 text-sm text-[#6B7280]">
        {patient.PRInterval ?? "—"}
      </td>

      {/* Priority / Urgency */}
      <td className="px-3 py-3">
        {patient.urgent ? (
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-red-100 text-red-700 border border-red-200">
            <AlertCircle className="w-3.5 h-3.5" />
            URGENT
          </span>
        ) : (
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600 border border-gray-200">
            Normal
          </span>
        )}
      </td>

      {/* TAT */}
      <td className="px-3 py-3 whitespace-nowrap">
        <TATTimer
          tatDeadline={patient.tat_deadline}
          tatStatus={patient.tat_status}
          tatRemainingSeconds={patient.tat_remaining_seconds}
        />
      </td>

      {/* Test Date */}
      <td className="px-3 py-3 text-sm text-[#6B7280] whitespace-nowrap">
        {patient.TestDate ?? "—"}
      </td>

      {/* Status */}
      <td className="px-3 py-3">
        <StatusBadge status={patient.status} />
      </td>

      {/* ECG Image */}
      <td className="px-3 py-3">
        {patient.Image ? (
          <a
            href={patient.Image}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm font-medium text-[#DC2626] hover:text-[#B91C1C] hover:underline"
          >
            <Eye className="w-3.5 h-3.5" />
            View ECG
          </a>
        ) : (
          <span className="text-xs text-[#D1D5DB]">
            —
          </span>
        )}
      </td>

      {/* Actions */}
      <td className="px-3 py-3">
        <button
          onClick={() => onView(patient)}
          className="inline-flex items-center gap-1 text-sm font-medium text-[#DC2626] hover:text-[#B91C1C] hover:underline"
        >
          <Eye className="w-3.5 h-3.5" />
          View
        </button>
      </td>
    </tr>
  );
}